"use client";
import React from "react";
import { Link } from "react-router-dom";

function PopularGuide() {
  const services = [
    {
      title: "Regulatory Compliance",
      desc: "Helping businesses stay compliant with industry regulations and legal requirements.",
      icon: "⚖️",
    },
    {
      title: "Corporate Governance",
      desc: "Building strong governance structures for transparency and business growth.",
      icon: "🏛️",
    },
    {
      title: "Employment Law",
      desc: "Professional legal support for employment policies and workplace compliance.",
      icon: "👨‍⚖️",
    },
    {
      title: "ITR E-Verification",
      desc: "Fast and secure Income Tax Return verification with digital solutions.",
      icon: "📄",
    },
  ];

  return (
    <section className="legal-section">

      {/* BACKGROUND */}
      <div className="bg-circle one"></div>
      <div className="bg-circle two"></div>

      <div className="container">

        {/* HEADING */}
        <div className="section-heading text-center">

          <h2>
            Our Legal Compliance
            <span> Solutions</span>
          </h2>

        </div>

        <div className="row align-items-center">

          {/* LEFT SIDE */}
          <div className="col-lg-5 mb-5 mb-lg-0">

            <div className="left-box">
              <h3>
                Trusted Legal Experts
                For Modern Businesses
              </h3>

              <p>
                We provide smart legal compliance solutions
                including governance, taxation, employment law,
                and regulatory consulting services.
              </p>

              <div className="features">

                <div className="feature-item">
                  <span className="check-icon">✓</span> Corporate Compliance
                </div>

                <div className="feature-item">
                  <span className="check-icon">✓</span> Tax & ITR Services
                </div>

                <div className="feature-item">
                  <span className="check-icon">✓</span> Employment Law Support
                </div>

              </div>

              <Link to="/contact">
                <button className="consult-btn">
                  Get Consultation →
                </button>
              </Link>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">

            <div className="services-grid">

              {services.map((item, index) => (
                <div className="service-card" key={index}>

                  <div className="icon-box">
                    {item.icon}
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                  <Link to="/contact" className="bottom-row text-decoration-none">

                    <span>Learn More</span>

                    <div className="arrow">
                      →
                    </div>

                  </Link>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .legal-section {
          position: relative;
          padding: 100px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
          overflow: hidden;
        }

        /* BACKGROUND CIRCLES */

        .bg-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.12;
          pointer-events: none;
        }

        .one {
          width: 400px;
          height: 400px;
          background: rgba(137, 199, 100, 0.15); /* Brand Green #89c764 tint */
          top: -150px;
          left: -150px;
        }

        .two {
          width: 450px;
          height: 450px;
          background: rgba(17, 88, 134, 0.12); /* Brand Navy #115886 tint */
          bottom: -150px;
          right: -150px;
        }

        .container {
          position: relative;
          z-index: 2;
        }

        /* HEADING */

        .section-heading {
          margin-bottom: 70px;
        }

        .tag {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 50px;
          background: rgba(17, 88, 134, 0.06);
          border: 1px solid rgba(17, 88, 134, 0.15);
          color: #115886;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1px;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .tag:hover {
          background: rgba(137, 199, 100, 0.1);
          border-color: rgba(137, 199, 100, 0.3);
          color: #76b151;
        }

        .section-heading h2 {
          font-size: 48px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .section-heading h2 span {
          color: #115886;
        }

        .section-heading p {
          max-width: 650px;
          margin: auto;
          color: #64748b;
          line-height: 1.8;
          font-size: 16px;
        }

        /* LEFT BOX */

        .left-box {
          background: linear-gradient(145deg, #0d3753 0%, #061c2b 100%);
          padding: 45px;
          border-radius: 30px;
          color: #fff;
          height: 100%;
          position: relative;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(17, 88, 134, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .left-box::before {
          content: "";
          position: absolute;
          width: 220px;
          height: 220px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 50%;
          top: -80px;
          right: -80px;
          pointer-events: none;
        }

        .left-box h3 {
          font-size: 32px;
          line-height: 1.4;
          margin-bottom: 20px;
          font-weight: 700;
        }

        .left-box p {
          color: #cbd5e1;
          line-height: 1.8;
          margin-bottom: 30px;
          font-size: 15px;
        }

        /* FEATURES */

        .features {
          margin-bottom: 35px;
        }

        .feature-item {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.08);
          padding: 14px 18px;
          border-radius: 14px;
          margin-bottom: 14px;
          color: #e2e8f0;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
        }

        .feature-item:hover {
          transform: translateX(8px);
          background: rgba(137, 199, 100, 0.12);
          border-color: rgba(137, 199, 100, 0.3);
        }

        .check-icon {
          color: #89c764;
          font-weight: 800;
          margin-right: 10px;
          font-size: 18px;
        }

        /* BUTTON */

        .consult-btn {
          border: none;
          padding: 16px 32px;
          border-radius: 14px;
          background: linear-gradient(135deg, #89c764, #76b151);
          color: #fff;
          font-weight: 700;
          transition: all 0.4s ease;
          box-shadow: 0 8px 24px rgba(137, 199, 100, 0.25);
          cursor: pointer;
          font-size: 15px;
        }

        .consult-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(137, 199, 100, 0.4);
          background: linear-gradient(135deg, #76b151, #629641);
        }

        /* SERVICES GRID */

        .services-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
        }

        .service-card {
          background: #fff;
          padding: 35px;
          border-radius: 28px;
          transition: all 0.4s ease;
          border: 1px solid rgba(17, 88, 134, 0.08);
          box-shadow: 0 10px 30px rgba(17, 88, 134, 0.02);
          position: relative;
          overflow: hidden;
          height: 100%;
        }

        .service-card::before {
          content: "";
          position: absolute;
          width: 180px;
          height: 180px;
          background: rgba(137, 199, 100, 0.03);
          border-radius: 50%;
          top: -70px;
          right: -70px;
          pointer-events: none;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(17, 88, 134, 0.08);
          border-color: rgba(137, 199, 100, 0.4);
        }

        .icon-box {
          width: 70px;
          height: 70px;
          border-radius: 20px;
          background: linear-gradient(135deg, #115886, #1e7ebd);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          color: #fff;
          margin-bottom: 22px;
          box-shadow: 0 10px 25px rgba(17, 88, 134, 0.2);
          transition: transform 0.4s ease, box-shadow 0.4s ease, background 0.4s ease;
        }

        .service-card:hover .icon-box {
          transform: rotate(10deg) scale(1.05);
          box-shadow: 0 12px 30px rgba(137, 199, 100, 0.3);
          background: linear-gradient(135deg, #89c764, #76b151);
        }

        .service-card h4 {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
        }

        .service-card p {
          color: #64748b;
          line-height: 1.8;
          margin-bottom: 30px;
          font-size: 15px;
        }

        .bottom-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          text-decoration: none !important;
        }

        .bottom-row span {
          color: #115886;
          font-weight: 700;
          transition: color 0.3s ease;
          text-decoration: none;
        }

        .service-card:hover .bottom-row span {
          color: #89c764;
        }

        .arrow {
          width: 45px;
          height: 45px;
          border-radius: 14px;
          background: #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #115886;
          transition: all 0.4s ease;
        }

        .service-card:hover .arrow {
          background: linear-gradient(135deg, #89c764, #76b151);
          color: #fff;
          transform: rotate(-45deg);
        }

        /* RESPONSIVE */

        @media (max-width: 992px) {
          .services-grid {
            grid-template-columns: 1fr;
          }

          .section-heading h2 {
            font-size: 38px;
          }
        }

        @media (max-width: 768px) {
          .legal-section {
            padding: 80px 0;
          }

          .section-heading h2 {
            font-size: 30px;
          }

          .left-box {
            padding: 30px;
          }

          .left-box h3 {
            font-size: 26px;
          }

          .service-card {
            padding: 28px;
          }
        }
      `}} />
    </section>
  );
}

export default PopularGuide;